export const useTabs = () => {
  const containers = document.querySelectorAll<HTMLDivElement>('.tabs');

  // Mobile-menu toggle for each tabs container
  containers.forEach(container => {
    const dropdown = container.querySelector<HTMLElement>('.tabs__mobile-menu-dropdown');

    dropdown?.addEventListener('click', () => {
      container.classList.toggle('tabs--active');
    });
  });

  // Get the URL parameters
  const urlParams = new URLSearchParams(window.location.search);

  containers.forEach(container => {
    // Get the active tab id from the URL parameters
    const activeTabId = urlParams.get(`${container.id}-selected-tab`);

    // If the tab container has a data attribute for useParams, we need to select the tab based on that
    if (container.dataset.useParams) {
      // Find by data-tab-id instead of id
      const tabElement = container.querySelector<HTMLElement>(`.tabs__tab[data-tab-id="${activeTabId}"]`);

      if (tabElement) {
        container
          .querySelectorAll<HTMLElement>('.tabs__tab--selected')
          .forEach(t => t.classList.remove('tabs__tab--selected'));
        tabElement.classList.add('tabs__tab--selected');
      }
    }
  });

  // Attach click-handlers to every tab in every container
  containers.forEach(container => {
    const tabs = container.querySelectorAll<HTMLElement>('.tabs__tab');

    tabs.forEach(tab => {
      tab.addEventListener('click', (e) => {
        // Remove the active class from the tabs container
        container?.classList.remove('tabs--active');

        // Deselect siblings and select the clicked tab
        tabs.forEach(t => t.classList.remove('tabs__tab--selected'));
        tab.classList.add('tabs__tab--selected');

        // Update the text in the mobile menu
        const mobileMenuTitle = container.querySelector<HTMLElement>('.tabs__mobile-menu-title');

        if (mobileMenuTitle) {
          mobileMenuTitle.textContent = tab.textContent || '';
        }

        // Grab the new tab-id from data attribute
        const tabId = tab.dataset.tabId;

        if (tabId) {
          // If the container has a data attribute for useParams, we need to update the URL parameters
          if (container.dataset.useParams) {
            const url = new URL(window.location.href);

            url.searchParams.set(`${container.id}-selected-tab`, tabId);
            window.history.pushState({}, '', url.toString());
          }

          // If the tab has an a-tag go to that URL
          const link = tab.querySelector<HTMLAnchorElement>('a');

          if (link) {
            window.location.href = link.href;
          }
        }
      });
    });
  });

  // Set correct mobile menu title on page load
  containers.forEach(container => {
    const mobileMenuTitle = container.querySelector<HTMLElement>('.tabs__mobile-menu-title');
    const selectedTab = container.querySelector<HTMLElement>('.tabs__tab--selected');

    if (mobileMenuTitle && selectedTab) {
      mobileMenuTitle.textContent = selectedTab.textContent || '';
    }
  });
};